<style scoped>
  @import '/src/assets/style.css';
 
  .hot-products{background:#eee;padding-bottom:2.7776041667vw}
  .hot-products .banner-box{margin-top:3.6109375vw;position:relative}
  .hot-products .banner-box .banner-img{width:100%;vertical-align:middle}
  .hot-products .banner-box .banner-slogan{width:100%;color:#db2017;font-family:SourceHanSansSC;position:absolute;top:0;text-align:center;margin-top:4.1666666667vw}
  .hot-products .banner-box .banner-slogan .title{font-size:4.0276041667vw;line-height:4.0276041667vw;margin-bottom:.8333333333vw;font-weight:700}
  .hot-products .banner-box .banner-slogan .tips{font-size:2.2223958333vw;line-height:2.2223958333vw;font-weight:500}
  .hot-products .banner-box .banner-slogan .confirm-btn{width:10.2776041667vw;height:2.2223958333vw;background:#db2017;margin:1.0416666667vw auto;border-radius:1.5625vw;font-weight:500;font-size:1.1458333333vw;color:#fff;display:flex;justify-content:center;align-items:center;cursor:pointer}
  .hot-products .products:last-child{margin-bottom:0}
  .hot-products .products{position:relative;width:100%;box-sizing:border-box;margin:1.3890625vw 0 2.7776041667vw;padding:0 2.2223958333vw}
  .hot-products .products-item{width:100%;height:30.1390625vw;position:relative}
  .hot-products .products-img{width:100%;height:100%}
  .hot-products .products-item .mask-item{z-index:-1;position:absolute;top:0;left:0;width:100%;height:100%}
  .hot-products .products-item:first-child:hover{cursor:pointer}
  .hot-products .products-item:nth-child(2){margin:1.3890625vw 0}
  .hot-products .products-item:first-child:hover .mask-item{z-index:5}
  .hot-products .products-item:first-child:hover .mask-item:after{content:"";position:absolute;top:0;left:0;width:100%;height:100%;background-color:hsla(0,0%,98%,.5);border-radius:.7291666667vw;z-index:-1}
  .hot-products .carousel{padding:0 2.2223958333vw;box-sizing:border-box;position:relative;top:-1.3020833333vw;width:100%}
  .hot-products .carousel-box{width:100%;background-color:#fff;border-radius:.7291666667vw;box-sizing:border-box;padding:1.4583333333vw 2.7776041667vw 0}
  .hot-products .carousel-box-top{width:100%;position:relative}
  .hot-products .carousel-box-top .carousel-3d-container{margin:0 auto}
  .carousel-3d-container{min-height:1px;width:100%;position:relative;z-index:0;overflow:hidden;margin:20px auto;box-sizing:border-box}
  .hot-products .carousel-box-top .title{position:absolute;top:0;width:100%;text-align:center;font-family:SourceHanSansSC;font-weight:700;font-size:4.0276041667vw;color:#000}
  .hot-products .carousel-box-top .icon-left{left:0}
  .hot-products .carousel-box-top .icon-left,.hot-products .carousel-box-top .icon-right{position:absolute;top:50%;width:2.3609375vw;height:2.3609375vw;cursor:pointer}
  .hot-products .carousel-box-top .icon-right{right:0}
  .carousel-3d-slide{background:none}
  .hot-products .carousel-box-top .carousel-3d-slide{background-color:transparent}
  .carousel-3d-slide.current{opacity:1 !important;visibility:visible !important;transform:none !important;z-index:999}
  .carousel-3d-slide{position:absolute;opacity:0;visibility:hidden;overflow:hidden;top:0;border-radius:1px;border-color:#000;border-color:rgba(0,0,0,.4);border-style:solid;background-size:cover;background-color:#ccc;display:block;margin:0;box-sizing:border-box;text-align:left}
  .hot-products .carousel-box-top .carousel-3d-slide .img.current{bottom:0;transform:scale(1);transition:all .2s}
  .hot-products .carousel-box-top .carousel-3d-slide .img{width:100%;height:auto;position:absolute;margin-left:auto;margin-right:auto;left:0;right:0}
  .hot-products .carousel-box-top .carousel-3d-slide.left-2 .img,.hot-products .carousel-box-top .carousel-3d-slide.right-2 .img{top:0;opacity:.5;transform:scale(.85);transition:all .2s}
  .hot-products .carousel-box-top .carousel-3d-slide.left-1 .img,.hot-products .carousel-box-top .carousel-3d-slide.right-1 .img{bottom:8%;transform:scale(.95);opacity:.75;transition:all .2s}
  .hot-products .carousel-box-top .carousel-3d-slide.left-1 .img,.hot-products .carousel-box-top .carousel-3d-slide.right-1 .img{bottom:8%;transform:scale(.95);opacity:.75;transition:all .2s}
  .hot-products .carousel-box-top .carousel-3d-slide.left-2 .img,.hot-products .carousel-box-top .carousel-3d-slide.right-2 .img{top:0;opacity:.5;transform:scale(.85);transition:all .2s}
  .hot-products .carousel-box-line{width:100%;height:.0692708333vw;background-color:#d9dbdc;margin-bottom:3.0604166667vw}
  .hot-products .carousel-box-bottom{width:100%;height:27.8125vw;padding-left:1.1807291667vw;box-sizing:border-box;display:flex}
  .hot-products .carousel-box-bottom .left{position:relative;width:25.7291666667vw;height:100%}
  .hot-products .carousel-box-bottom .right{width:calc(100% - 25.72917vw);height:100%;padding-left:3.75vw;box-sizing:border-box}
  .hot-products .carousel-box-bottom .right .title{font-family:SourceHanSansSC;font-weight:700;font-size:2.0833333333vw;color:#fff;line-height:2.0833333333vw;padding:.4166666667vw 2.8125vw;background-color:#db2017;border-radius:2.8125vw;margin-top:.7640625vw;margin-bottom:4.1666666667vw;width:-moz-max-content;width:max-content}
  .hot-products .carousel-box-bottom .right .list{width:100%;font-family:SourceHanSansSC;font-weight:400;font-size:1.25vw;color:#000;line-height:2.3265625vw;display:flex;justify-content:flex-start;align-items:flex-start}
  .hot-products .carousel-box-bottom .right .list-item{width:33%}
  .hot-products .carousel-box-bottom .right .list .icon{width:4.7395833333vw;height:4.7395833333vw}
  .hot-products .carousel-box-bottom .left .back{position:absolute;left:1.0416666667vw;top:0;width:23.6109375vw;height:23.6109375vw;background-image:url(/public/img/back.c52d8af.png);background-size:cover}
  .hot-products .carousel-box-bottom .left .goods{position:absolute;transition:all .1s ease-in}
  .hot-products .carousel-box-bottom .left .goods0{width:25.6770833333vw;height:27.7604166667vw;left:0;top:-.5208333333vw}
  .hot-products .carousel-box-bottom .left .goods1{width:19.4791666667vw;height:18.3333333333vw;left:0;right:0;margin:0 auto;top:4.2708333333vw}
  .hot-products .carousel-box-bottom .left .goods2{width:20.5208333333vw;height:27.8125vw;left:0;right:0;margin:0 auto;top:-1.1458333333vw}
  .hot-products .carousel-box-bottom .left .goods3{width:23.6458333333vw;height:24.1666666667vw;left:1.0416666667vw;top:1.7708333333vw}
  .hot-products .carousel-box-bottom .left .goods4{width:23.6458333333vw;height:24.1666666667vw;left:1.0416666667vw;top:1.7708333333vw}
  .hot-products .carousel-box-bottom .left .goods5{width:23.9583333333vw;height:20.8333333333vw;left:1.0416666667vw;top:4.4791666667vw}
  .hot-products .carousel-box-bottom .left .goods6{width:14.6875vw;height:29.375vw;left:5.5208333333vw;top:-1.5625vw}
  .hot-products .carousel-box-bottom .left .goods7{width:12.0833333333vw;height:29.8958333333vw;left:6.6666666667vw;top:-2.0833333333vw}

</style>

<template>
  <div class="hot-products page">
    <div class="banner-box">
        <img src="/img/products.1fbac38.png" class="banner-img">
        <div class="banner-slogan">
          <div class="title">Sản phẩm đổi mới đa dạng</div>
          <div class="tips">Đáp ứng mọi nhu cầu sử dụng</div>
          <div class="confirm-btn">Tìm hiểu thêm</div>
        </div>
    </div>
    <div id="powerBank" class="carousel">
      <div class="carousel-box" >
        <div class="carousel-box-top">
          <carousel-3d ref="carousel" :animationSpeed="1000" autoplay="true" :width="333" :height="566" :count="5" :border="0" :perspective="0" :space="500" :loop="true" @before-slide-change="onSlideChange">
            <slide v-for="(item,index) in list" :key="index" :index='index'>
              <img :src="BASE_URL +item.ico" :class="['img', `swiper${index}`, { 
                current: activeIndex === index,
                onLeft: isOnLeft(index),
                onRight: isOnRight(index),
              }]">
            </slide>
          </carousel-3d>
          <div class="title">Dòng sạc dự phòng</div>
          <img src="/img/left.8f2cc8f.png" alt="" class="icon-left" @click="slidePrev">
          <img src="/img/right.8eb598c.png" alt="" class="icon-right" @click="slideNext">
        </div>
        <div class="carousel-box-line"></div>
        <div class="carousel-box-bottom">
          <div class="left">
            <div class="back"></div>
            <img :src="BASE_URL +list[activeIndex].ico" alt="" class="goods goods4">
          </div>
          <div class="right">
            <div class="title">{{ list[activeIndex].title }}</div>
            <div class="list">
              <div class="list-item">
                <div v-html="list[activeIndex].ext.ext_item1"></div>
              </div>
              <div class="list-item">
                <div v-html="list[activeIndex].ext.ext_item2"></div>
              </div>
              <div class="list-item">
                <div v-html="list[activeIndex].ext.ext_item3"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="chargingPile" class="products">
      <div class="products-item">
        <img src="/img/ad1.png" alt="" class="products-img">
      </div>
      <div class="products-item">
        <img src="/img/ad2.png" alt="" class="products-img">
      </div>
      <div class="products-item">
        <img src="/img/ad3.png" alt="" class="products-img">
      </div>
    </div>
  </div>
</template>
<script>
import { BASE_URL } from '@/config';
import axios from 'axios'; // 引入 axios
import { Carousel3d, Slide } from 'vue-carousel-3d';


export default {
  components: {
    Carousel3d,
    Slide,
  },
  data() {
    return {
      activeIndex: 0,
      list: [],
      BASE_URL
    };
  },
  methods: {
    
    onSlideChange(temp) {
      this.activeIndex = temp;
      this.$emit('getData', this.list[temp].title)
    },
    slidePrev() {
      let prevIndex = (this.activeIndex - 1 + this.list.length) % this.list.length;
      this.$refs.carousel.goSlide(prevIndex);
    },

    slideNext() {
      let nextIndex = (this.activeIndex + 1) % this.list.length;
      this.$refs.carousel.goSlide(nextIndex);
    },
    isOnLeft(index) {
    const leftIndexes = [
      (this.activeIndex - 1 + this.list.length) % this.list.length,
      (this.activeIndex - 2 + this.list.length) % this.list.length
    ];
    return leftIndexes.includes(index);
  },
  isOnRight(index) {
    const rightIndexes = [
      (this.activeIndex + 1) % this.list.length,
      (this.activeIndex + 2) % this.list.length
    ];
    return rightIndexes.includes(index);
  }
  },
  mounted() {
  const path = window.location.pathname;
  const menu = document.querySelector('.menu');
  if (menu) {
    const menuItems = menu.querySelectorAll('.menu-item');
    menuItems.forEach(item => {
      const linkDiv = item.querySelector('.menu-item-link');
      const aTag = linkDiv ? linkDiv.querySelector('a') : null;
      if (linkDiv && aTag) {
        // 只要a标签的href和当前路径一致就高亮
        if (aTag.getAttribute('href') === path) {
          linkDiv.classList.add('active-route');
        } else {
          linkDiv.classList.remove('active-route');
        }
      }
    });
  }
  // 获取产品列表
  axios.get(`${BASE_URL}/index/index/productlist?lang=vn`,{
    params: {
      model: 1
    }
  }).then(res => {
        if (res.data) {
            this.list = res.data.products;
        } else {
          console.error('未获取到有效数据');
        }
      })
      .catch(error => {
        console.error('获取数据失败:', error);
      });

    // 给.header加product类
    const header = document.querySelector('.header');
    if (header && !header.classList.contains('product')) {
      header.classList.add('product');
    }
  },
};
</script>
